export default "__VITE_ASSET__CZZbgpv0__"